<template>
    <div v-if="calendar.month_title">
        <div class="col-sm mw-480 mb-4">
            <h5 class="w-100 bg-dark p-2 text-white text-center mb-1">
                {{ calendar.month_title }} </h5>
            <div class="sku_name cal_values">{{ calendar.sku_name }}</div>
            <div class="sku_id cal_values">{{ calendar.sku_id }}</div>
            <div class="calendar-month">
                <div class="day-of-week">Sun</div>
                <div class="day-of-week">Mon</div>
                <div class="day-of-week">Tue</div>
                <div class="day-of-week">Wed</div>
                <div class="day-of-week">Thu</div>
                <div class="day-of-week">Fri</div>
                <div class="day-of-week">Sat</div>
                <div v-for="index in 42" :key="index"
                     :class="day_class(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7))">
                    {{ day_of_month(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7)) }}
                    <div v-if="day_class(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7)).includes('available')"
                         class="cal_values">
                        <div v-if="calendar.dates.rate_schedules && calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7))]"
                             class="cal_rate_name">
                            {{
                                calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7),
                                                                       1 + ((index - 1) % 7))].name
                            }}
                        </div>
                        <div v-if="calendar.dates.rate_schedules && calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7))]"
                             class="cal_rate">
                            {{
                                calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7),
                                                                       1 + ((index - 1) % 7))].price
                            }}
                        </div>
                        <div v-if="calendar.dates.rate_schedules && calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7), 1 + ((index - 1) % 7))]"
                             class="cal_minimum">
                            {{
                                calendar.dates.rate_schedules[dayIndex(1 + Math.trunc((index - 1) / 7),
                                                                       1 + ((index - 1) % 7))].min_nights
                            }} Night Min
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:       'App',
    components: {},
    props:      [
        'sku_id',
        'month',
        'year'
    ],
    data()
    {
        return {
            calendar:  {
                month_title: '',
                sku_name:    '',
                dates:       {'cal_months': []},
            },
            cal_state: 'init'
        }
    },
    watch:   {
        month(val)
        {
            this.load_calendar()
        }
    },
    methods: {
        day_of_month(row, col)
        {
            if (this.calendar.dates && this.calendar.dates.cal_months && this.calendar.dates.cal_months.length > 0)
            {
                let rowcol = ((col - 1) + (row - 1) * 7) - this.calendar.dates.cal_months[0].monthrange[0] + 1
                return rowcol > 0 && rowcol < this.calendar.dates.cal_months[0].monthrange[1] + 1 ? rowcol : ''
            }
        },
        dayIndex(row, col)
        {
            if (this.calendar.dates && this.calendar.dates.cal_months && this.calendar.dates.cal_months.length > 0)
            {
                let dom = this.day_of_month(row, col)
                return this.year + '-' + String(this.month)
                    .padStart(2, '0') + '-' + String(dom).padStart(2, '0')
            }
            else
            {
                return 0
            }
        },
        day_class(row, col)
        {
            let my_class = ['day']
            if (this.dayIndex(row, col))
            {
                let booking_date = this.calendar.dates.booking_dates[this.dayIndex(row, col)]
                if (booking_date)
                {
                    my_class.push('day-inside')
                    if (this.calendar.dates)
                    {
                        let rate_schedule = this.calendar.dates.rate_schedules[this.dayIndex(row, col)]
                        if (booking_date.eid || rate_schedule.name === 'No Bookings')
                        {
                            my_class.push('booked')
                        }
                        else
                        {
                            my_class.push('available')
                        }
                    }
                }
                else
                {
                    my_class.push('day-outside')
                }
            }
            return my_class
        },
        load_calendar()
        {
            this.calendar.month_title = ''
            let server = window.location.hostname === 'localhost' ? 'http://localhost' : ''

            this.$http.get(server + "/ws/sku_calendar_month", {
                params: {
                    sku_id: this.sku_id,
                    year:   this.year,
                    month:  this.month
                }
            }).then(response =>
                    {
                        this.calendar = response.data
                        if (this.calendar.dates.length === 0)
                        {
                            this.cal_state = 'no_dates'
                        }
                        else
                        {
                            this.cal_state = 'loaded'
                        }
                    }).catch(err =>
                             {
                                 this.cal_state = 'error'
                             })


        }
    },
    created()
    {
        this.load_calendar()
    }
}
</script>

<style>
</style>
